<template>
  <div>
    <div style="border:0px solid red;padding-top:20px;display:none">
      <div class="mapTitle" style="left:35%"><a @click="selectArea('china','china')" style="color:#fff;cursor: pointer; text-decoration:none" href="javascript:void(0)">全国</a></div>
      <div class="mapTitle" style="right:35%"><a @click="selectArea('ningxia','宁夏')" style="color:#fff;cursor: pointer; text-decoration:none" href="javascript:void(0)">宁夏</a></div>
    </div>
    <div id="cityMap" ref="cityMap" :style="mapHeight"></div>
  </div>
</template>

<script>
import {selectMap} from '@/api/dataview/map'
import axios from 'axios'
var echartsMap
export default {
  name: 'Map1',
  data () {
    return {
      mapHeight: { width: '100%', height: '100%' },
      // provinces: ['shanghai', 'hebei', 'shanxi', 'neimenggu', 'liaoning', 'jilin', 'heilongjiang', 'jiangsu', 'zhejiang', 'anhui', 'fujian', 'jiangxi', 'shandong', 'henan', 'hubei', 'hunan', 'guangdong', 'guangxi', 'hainan', 'sichuan', 'guizhou', 'yunnan', 'xizang', 'shanxi1', 'gansu', 'qinghai', 'ningxia', 'xinjiang', 'beijing', 'tianjin', 'chongqing', 'xianggang', 'aomen', 'taiwan'],
      provincesText: ['上海', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '北京', '天津', '重庆', '香港', '澳门', '台湾'],
      convertData: null,
      special: ['北京'],
      mapdata: [],
      type: 'china',
      option: {},
      provinces: {
        '上海':	'shanghai',
        '河北':	'hebei',
        '山西':	'shanxi',
        '内蒙古':	'neimenggu',
        '辽宁':	'liaoning',
        '吉林':	'jilin',
        '黑龙江':	'heilongjiang',
        '江苏':	'jiangsu',
        '浙江':	'zhejiang',
        '安徽':	'anhui',
        '福建':	'fujian',
        '江西':	'jiangxi',
        '山东':	'shandong',
        '河南':	'henan',
        '湖北':	'hubei',
        '湖南':	'hunan',
        '广东':	'guangdong',
        '广西':	'guangxi',
        '海南':	'hainan',
        '四川':	'sichuan',
        '贵州':	'guizhou',
        '云南':	'yunnan',
        '西藏':	'xizang',
        '陕西':	'shanxi1',
        '甘肃':	'gansu',
        '青海':	'qinghai',
        '宁夏':	'ningxia',
        '新疆':	'xinjiang',
        '北京':	'beijing',
        '天津':	'tianjin',
        '重庆':	'chongqing',
        '香港': 'xianggang',
        '澳门':	'aomen',
        '台湾':	'taiwan'
      },
      d_color : ['#1890FF', '#91CB74', '#FAC858', '#EE6666', '#73C0DE', '#3CA272', '#FC8452', '#9A60B4', '#ea7ccc']
    }
  },
  mounted () {
    let selected = 'china'
    this.mapEcharts(selected)

  },
  methods: {
    selectArea (type, provinceName) {
      var that = this
      if (type !== 'china') {
        // 濡傛灉鐐瑰嚮鐨勬槸34涓渷銆佸競銆佽嚜娌诲尯锛岀粯鍒堕€変腑鍦板尯鐨勪簩绾у湴鍥�
        axios.get('/json/province/' + type + '.json').then(res => {
          that.$echarts.registerMap(provinceName, res.data)
          var d = []
          for (var i = 0; i < res.data.features.length; i++) {
            d.push({
              name: res.data.features[i].properties.name
            })
          }

          that.type = 'province'
          that.renderMap(provinceName, d,res)
        })
      } else {
        that.$echarts.registerMap('china', that.mapdata)
        var d = []
        for (var i = 0; i < that.mapdata.features.length; i++) {
          d.push({
            name: that.mapdata.features[i].properties.name
          })
        }
        that.type = 'china'
        that.renderMap('china', d,that.mapdata)
      }
    },
    async renderMap (code, map, data, oldres) {
      var that = this
      var param = {}
      var sj = [];
      console.log("data",code)
      var china_data=[];
      if (map !== 'china') {
        param.provinceCode = code.slice(0,2)
        await selectMap(param).then(result => {
          //console.log(result)
          for (var j = 0; j < result.data.length; j++) {
            var zb = [];
            for(var k=0;k<oldres.data.features.length; k++) {
              //console.log(result.data[0].name,oldres.data.features[k].properties.name)
              if(result.data[0].name===oldres.data.features[k].properties.name){
                zb = oldres.data.features[k].properties.cp;
                break;
              }
            }
            var datax = {
              coord: zb,
              data: result.data[j].list,
              name: result.data[j].name,
              symbol: 'image://' + require('../../assets/img/point.png'),
              size: 1,
              count: result.data[j].sum,
            }
            sj.push(datax)
          }
        })
      } else {
        await selectMap(null).then(result => {
          //console.log(JSON.stringify(oldres))

          for(var kk=0;kk<oldres.features.length;kk++) {
            var json = {};
            json.name = oldres.features[kk].properties.name;
            json.value = oldres.features[kk].id;
            china_data.push(json)
          }

          for (var j = 0; j < result.data.length; j++) {
            var zb = [];
            for (var k = 0; k < oldres.features.length; k++) {
              console.log(result.data[j].name.slice(0,2),oldres.features[k].properties.name)
              if(result.data[j].name.slice(0,2)===oldres.features[k].properties.name){
                zb = oldres.features[k].properties.cp;
                break;
              }
            }
            var datax = {
              coord: zb,
              data: result.data[j].list,
              name: result.data[j].name,
              symbol: 'image://' + require('../../assets/img/point.png'),
              size: 80,
              count: result.data[j].sum,
            }
            sj.push(datax)
          }
        })
      }
      // that.option.title.subtext = map
      that.option.series = [
        {
          name: map,
          type: 'map',
          mapType: map,
          roam: false,
          nameMap: {
            'china': '中国'
          },
          data: china_data,
          label: {
            normal: {
              show: false,
              textStyle: {
                color: '#fff'
              }
            },
            emphasis: {
              show: false,
              textStyle: {
                color: '#000'
              }
            }
          },
          markPoint: {
            symbol: 'image://static/img/point.png', // 自定义图片路径
            symbolSize: 15, // 图片大小
            label: {
              position: 'top',
              color: '#fff'
            },
            // coord数组存放地址坐标
            data: sj
          },
          itemStyle: {
            normal: {
              areaColor: '#0074BC', // '#4A9DE4',
              borderColor: '#A2D9FC',
              borderWidth: 1
            },
            emphasis: {
              areaColor: '#fff',
              shadowOffsetX: 10,
              shadowOffsetY: 10,
              shadowBlur: 5,
              borderWidth: 2,
              shadowColor: '#0074BC',
              borderColor: 'rgba(0, 0, 0, 0)'
            }
          }
        }
      ]
      // 娓叉煋鍦板浘
      echartsMap.setOption(that.option)
    },
    mapEcharts (name) {
      // console.log(name)
      var that = this
      echartsMap = that.$echarts.init(document.getElementById('cityMap'))

      // $.ajaxSettings.async = false
      axios.get('json/china.json').then(res => {
        //console.log(res.data)
        var dataMap = res.data
        that.mapdata = res.data
        that.$echarts.registerMap(name, dataMap)

        var china_data=[];
        for(var k=0;k<dataMap.features.length;k++) {
          var json = {};
          json.name = dataMap.features[k].properties.name;
          json.value = dataMap.features[k].id;
          //json.code = dataMap.features[k].id;
          china_data.push(json)
          //china_data[k]=dataMap.features[k].id
        }

        selectMap(null).then(result => {
          var sj = [];
          for (var j = 0; j < result.data.length; j++) {
            var zb = [];
            for (var k = 0; k < dataMap.features.length; k++) {
              console.log(result.data[j].name.slice(0,2),dataMap.features[k].properties.name)
              if(result.data[j].name.slice(0,2)===dataMap.features[k].properties.name){
                zb = dataMap.features[k].properties.cp;
                break;
              }
            }
            var datax = {
              coord: zb,
              data: result.data[j].list,
              name: result.data[j].name,
              symbol: 'image://' + require('../../assets/img/point.png'),
              size: 80,
              count: result.data[j].sum,
            }
            sj.push(datax)
          }
          that.option = {
            // backgroundColor: '#000',
            visualMap: {
              min: 0,
              max: 1000,
              left: 26,
              bottom: 40,
              showLabel: !0,
              text: ['高', '低'],
              pieces: [{
                gte: 1,
                color: '#0550c3'
              }, {
                value: 0,
                color: 'rgba(0, 0, 0, 0.3)'
              }],
              show: false
            },
            series: [
              {
                name: name,
                type: 'map',
                mapType: name,
                roam: false,
                selectedMode:'single',
                nameMap: {
                  'china': '中国'
                },
                data:china_data,
                label: {
                  normal: {
                    show: false,
                    textStyle: {
                      color: '#fff'
                    },
                    // formatter: function (params) {
                    //   // console.log(params)
                    //   if (params.value) {
                    //     //return params.name + '：' + params.value + '户' // 大头针标记上显示的信息
                    //   } else {
                    //     //return '' // 大头针标记上显示的信息
                    //   }
                    // }
                  },
                  emphasis: {
                    show: false,
                    textStyle: {
                      color: '#000'
                    }
                  }
                },
                itemStyle: {
                  normal: {
                    areaColor: '#0074BC', // '#4A9DE4',
                    borderColor: '#A2D9FC',
                    borderWidth: 1
                  },
                  emphasis: {
                    areaColor: '#fff',
                    shadowOffsetX: 10,
                    shadowOffsetY: 10,
                    shadowBlur: 5,
                    borderWidth: 2,
                    shadowColor: '#0074BC',
                    borderColor: 'rgba(0, 0, 0, 0)'
                  }
                },
                markPoint: {
                  symbol: 'image://static/img/point.png', // 自定义图片路径
                  symbolSize: 15, // 图片大小
                  label: {
                    position: 'top',
                    color: '#fff'
                  },
                  // coord数组存放地址坐标
                  data: sj
                }
                // data: convertData2(ceshi)
              }
            ],
            title: {
              show:false,
              // text: '涓浗鍦板浘',
              // subtext: '鐪佸競鍖轰笁绾т笅閽�',
              link: 'http://www.ldsun.com',
              left: 'center',
              textStyle: {
                color: '#fff',
                fontSize: 16,
                fontWeight: 'normal',
                fontFamily: 'Microsoft YaHei'
              },
              subtextStyle: {
                color: '#ccc',
                fontSize: 13,
                fontWeight: 'normal',
                fontFamily: 'Microsoft YaHei'
              }
            },
            tooltip: {
              trigger: 'item',
              confine: true,
              // formatter: '{b}<br/>{c} (p / km2)'
              triggerOn: 'mousemove',
              formatter: function (params) {

                if (params.data !== undefined) {
                  if (params.data.data !== undefined) {
                    console.log("params",params)
                    var val = "<b>" + params.name + "</b>   <span style='float:right;color:green'>"+params.data.count+"</span><br>";
                    for (var j = 0; j < params.data.data.length; j++) {
                      val += '<span style="display:inline-block;position:relative; top:0px;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + that.d_color[j] + '"></span><span style="font-size:13px">' + params.data.data[j].categoryName + "</span>：<span style='float:right;color:"+that.d_color[j]+"'>" + params.data.data[j].count + "</span><br>"
                    }
                    return val;
                  }
                }
              },
              backgroundColor: '#fff',
              // 额外附加的阴影
              extraCssText: 'box-shadow:0 0 4px rgba(11, 19, 43,0.8);'
            }
            // animationDuration: 1000,
            // animationEasing: 'cubicOut',
            // animationDurationUpdate: 1000

          }

          echartsMap.setOption(that.option)

          window.addEventListener("resize", function() {
            echartsMap.resize();
          });


          echartsMap.on('click', function (params) {
            console.log(params)

            if (params.name in that.provinces && that.type === 'china') {
              var code = params.data.value;
              // 濡傛灉鐐瑰嚮鐨勬槸34涓渷銆佸競銆佽嚜娌诲尯锛岀粯鍒堕€変腑鍦板尯鐨勪簩绾у湴鍥�
              axios.get('/json/province/' + that.provinces[params.name] + '.json').then(res => {
                that.$echarts.registerMap(params.name, res.data)
                var d = []
                for (var i = 0; i < res.data.features.length; i++) {
                  d.push({
                    name: res.data.features[i].properties.name
                  })
                }
                name = params.name
                that.type = 'province'
                that.renderMap(code,params.name, d,res)
              })
            } else {
              that.$echarts.registerMap('china', that.mapdata)
              var d = []
              for (var i = 0; i < that.mapdata.features.length; i++) {
                d.push({
                  name: that.mapdata.features[i].properties.name
                })
              }
              that.type = 'china'
              that.renderMap(null,'china', d,that.mapdata)
            }
          })
        })


      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .mapTitle
    position absolute
    background url(../../assets/img/border.png)
    width 200px
    height 60px
    background-size 100% 100%
    border:0px solid yellow
    color #fff
    font-size 26px
    text-align center
    line-height 60px
    z-index 999
</style>
